<router-outlet
  ><cam-alert-toast class="global-toast"></cam-alert-toast
></router-outlet>
@if (showNotificationPopup()) {
  <app-notification-permission />
}
